import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import Axios from "axios";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";

const AddUpdateLanguage = () => {
  const { id } = useParams();
  const history = useHistory();
  const [name, setName] = useState("");
  const [label, setLabel] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    if (id) {
      fetchLanguage();
    }
  }, [id]);

  const fetchLanguage = async () => {
    setLoading(true);
    setError("");
    try {
      const token = getAccessToken();
      const response = await Axios.get(
        Constant.apiBasePath + `language/getById/${id}`,
        { headers: { token } }
      );
      if (response.data && response.data.name) {
        setName(response.data.name || "");
        setLabel(response.data.label || "");
      } else if (
        response.data &&
        response.data.data &&
        response.data.data.name
      ) {
        setName(response.data.data.name || "");
        setLabel(response.data.data.label || "");
      } else {
        setError(
          (response.data && response.data.message) || "Failed to fetch language"
        );
      }
    } catch (err) {
      setError("Error fetching language");
    }
    setLoading(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      const token = getAccessToken();
      const payload = { name, label };
      let response;
      if (id) {
        response = await Axios.put(
          Constant.apiBasePath + `language/edit/${id}`,
          payload,
          { headers: { token } }
        );
      } else {
        response = await Axios.post(
          Constant.apiBasePath + "language/",
          payload,
          { headers: { token } }
        );
      }
      if ((!id && response.status === 201) || (id && response.status === 200)) {
        setSuccess(
          id ? "Language updated successfully" : "Language added successfully"
        );
        setTimeout(() => history.push("/language-management"), 1000);
      } else {
        setError(
          response.data && response.data.message
            ? response.data.message
            : "Failed to save language"
        );
      }
    } catch (err) {
      setError("Error saving language");
    }
    setLoading(false);
  };

  return (
    <div className="content-page contest-add-update-page event-consistent-page language-add-page">
      <div className="content page-content-spaced">
        <div className="event-management-header">
          <div className="header-content">
            <div className="header-title">
              <h4 className="page-title-heading">{id ? "Edit" : "Add"} Language</h4>
              <p className="header-subtitle">
                Create or update language name and label details.
              </p>
            </div>
            <div className="header-actions">
              <Link to="/language-management" className="btn openmic-link-btn">Back to Language Management</Link>
            </div>
          </div>
        </div>

        <div className="event-management-body">
          <div className="row">
            <div className="col-12 contest-form-column">
              <div className="card contest-form-card">
                <div className="card-body contest-form-card-body">
                  <form onSubmit={handleSubmit}>
                    <p id="gen-message" className="message-feedback">
                      {error || success}
                    </p>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label>Name</label>
                          <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label>Label</label>
                          <input
                            type="text"
                            className="form-control"
                            value={label}
                            onChange={(e) => setLabel(e.target.value)}
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="d-flex flex-wrap align-items-center" style={{ gap: '10px' }}>
                      <button
                        type="submit"
                        className="btn btn-primary btn-add-event contest-add-match"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : id ? "Update" : "Add"}
                      </button>
                      <button
                        type="button"
                        className="btn openmic-link-btn"
                        onClick={() => history.push("/language-management")}
                        disabled={loading}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUpdateLanguage;
